import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "edit-file-card" }
const _hoisted_2 = {
  key: 0,
  class: "edit-file-muted"
}
const _hoisted_3 = {
  key: 1,
  class: "edit-file-muted"
}
const _hoisted_4 = {
  key: 2,
  class: "files-list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "file-name" }
const _hoisted_7 = { class: "file-actions" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 3,
  class: "replace-block"
}
const _hoisted_10 = { class: "replace-hint" }
const _hoisted_11 = { class: "replace-row" }
const _hoisted_12 = {
  key: 0,
  class: "replace-new"
}
const _hoisted_13 = {
  key: 1,
  class: "replace-none"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "replace-actions" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  class: "add-new-files-block",
  style: {"margin-top":"20px","border-top":"1px dashed #e2e8f0","padding-top":"15px"}
}
const _hoisted_18 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_19 = {
  class: "selected-files-list",
  style: {"flex":"1"}
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 1,
  class: "edit-file-muted",
  style: {"font-size":"12px"}
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "popup-header popup-header--activity" }
const _hoisted_25 = { class: "popup-header-main" }
const _hoisted_26 = { class: "popup-header-texts" }
const _hoisted_27 = { class: "popup-header-title" }
const _hoisted_28 = { class: "popup-header-meta" }
const _hoisted_29 = { class: "details-container" }
const _hoisted_30 = { class: "stats-grid" }
const _hoisted_31 = { class: "stat-card stat-card--cost" }
const _hoisted_32 = { class: "stat-content" }
const _hoisted_33 = { class: "stat-value" }
const _hoisted_34 = { class: "stat-card stat-card--date" }
const _hoisted_35 = { class: "stat-content" }
const _hoisted_36 = { class: "stat-value" }
const _hoisted_37 = { class: "info-sections-grid" }
const _hoisted_38 = { class: "info-column" }
const _hoisted_39 = { class: "info-section-card" }
const _hoisted_40 = { class: "info-list" }
const _hoisted_41 = { class: "info-item" }
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "info-item" }
const _hoisted_44 = { class: "value highlight" }
const _hoisted_45 = { class: "info-item" }
const _hoisted_46 = { class: "value" }
const _hoisted_47 = { class: "info-section-card" }
const _hoisted_48 = { class: "info-section-card" }
const _hoisted_49 = { class: "info-list" }
const _hoisted_50 = {
  key: 0,
  class: "info-item"
}
const _hoisted_51 = {
  key: 1,
  class: "info-item"
}
const _hoisted_52 = {
  key: 2,
  class: "info-item"
}
const _hoisted_53 = { class: "files-list" }
const _hoisted_54 = { class: "file-name" }
const _hoisted_55 = { class: "file-actions" }
const _hoisted_56 = { class: "info-column" }
const _hoisted_57 = { class: "info-section-card" }
const _hoisted_58 = { class: "info-list" }
const _hoisted_59 = { class: "info-item" }
const _hoisted_60 = { class: "value multiline" }
const _hoisted_61 = { class: "info-section-card" }
const _hoisted_62 = { class: "info-list" }
const _hoisted_63 = { class: "info-item" }
const _hoisted_64 = { class: "value success" }
const _hoisted_65 = { class: "info-item" }
const _hoisted_66 = { class: "value" }
const _hoisted_67 = { class: "system-meta-card" }
const _hoisted_68 = { class: "meta-row" }
const _hoisted_69 = { class: "meta-item" }
const _hoisted_70 = {
  ref: "popupBody",
  class: "popup-body-simple popup-body-modern"
}
const _hoisted_71 = { class: "form-content form-content-modern" }
const _hoisted_72 = { style: {"display":"flex","flex-direction":"column","gap":"8px"} }
const _hoisted_73 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_74 = {
  class: "selected-files-list",
  style: {"flex":"1"}
}
const _hoisted_75 = { key: 0 }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = {
  key: 1,
  style: {"font-size":"12px","color":"#94a3b8"}
}
const _hoisted_78 = { class: "form-footer footer-fixed footer-modern" }
const _hoisted_79 = { class: "footer-left" }
const _hoisted_80 = { class: "footer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxGridToolbarItem = _resolveComponent("DxGridToolbarItem")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxGridToolbar = _resolveComponent("DxGridToolbar")!
  const _component_DxTexts = _resolveComponent("DxTexts")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxFormItemGrid = _resolveComponent("DxFormItemGrid")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxFormItem = _resolveComponent("DxFormItem")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxForm = _resolveComponent("DxForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DxDataGrid, {
      ref: "dataGrid",
      allowColumnReordering: true,
      "data-source": {
      store: _ctx.dsActivitati,
      filter: _ctx.gridFilter
    },
      allowColumnResizing: true,
      "key-expr": "ID",
      columnAutoWidth: false,
      columnResizingMode: 'nextColumn',
      "show-borders": true,
      syncLookupFilterValues: false,
      "filter-sync-enabled": true,
      "show-row-lines": true,
      "show-column-lines": false,
      allowMerging: 'Cells',
      height: "100%",
      class: "grid theme-dependent",
      onExporting: _ctx.onExporting,
      onEditingStart: _ctx.onEditingStart,
      onRowRemoving: _ctx.onRowRemoving,
      onRowRemoved: _ctx.onRowRemoved
    }, {
      accountCellEditorTipActivitate: _withCtx(({ data }) => [
        _createVNode(_component_DxDropDownBox, {
          "data-source": _ctx.dsTipActivitati,
          "value-expr": "ID",
          "display-expr": _ctx.displayTipActivitate,
          value: data.value,
          opened: _ctx.isActivityDdbOpen,
          "onUpdate:opened": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isActivityDdbOpen) = $event)),
          "show-clear-button": true
        }, {
          content: _withCtx(() => [
            _createVNode(_component_DxDataGrid, {
              "data-source": _ctx.dsTipActivitati,
              "key-expr": "ID",
              columns: ['Nume'],
              height: "100%",
              onSelectionChanged: e => {
                const id = e.selectedRowKeys?.[0] ?? null;
                data.setValue(id);
                _ctx.isActivityDdbOpen = false;
              }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSelection, { mode: "single" })
              ]),
              _: 1
            }, 8, ["data-source", "onSelectionChanged"])
          ]),
          _: 2
        }, 1032, ["data-source", "display-expr", "value", "opened"])
      ]),
      accountCellEditor: _withCtx(({ data }) => [
        _createVNode(_component_DxDropDownBox, {
          "data-source": _ctx.dsParteneri,
          "value-expr": "ID",
          "display-expr": _ctx.displayCompanie,
          value: data.value,
          opened: _ctx.isAccountDdbOpen,
          "onUpdate:opened": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isAccountDdbOpen) = $event)),
          "show-clear-button": true
        }, {
          content: _withCtx(() => [
            _createVNode(_component_DxDataGrid, {
              "data-source": _ctx.dsParteneri,
              "key-expr": "ID",
              columns: ['Nume'],
              height: "100%",
              onSelectionChanged: e => {
              const id = e.selectedRowKeys?.[0] ?? null;
              data.setValue(id);
              _ctx.isAccountDdbOpen = false;
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSelection, { mode: "single" })
              ]),
              _: 1
            }, 8, ["data-source", "onSelectionChanged"])
          ]),
          _: 2
        }, 1032, ["data-source", "display-expr", "value", "opened"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxScrolling, { mode: 'virtual' }),
        _createVNode(_component_DxColumnChooser, {
          enabled: true,
          "allow-search": true,
          title: "Selector coloane"
        }),
        _createVNode(_component_DxPaging, { "page-size": 20 }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxHeaderFilter, { visible: false }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxLoadPanel, { "show-pane": false }),
        _createVNode(_component_DxExport, {
          enabled: true,
          "allow-export-selected-data": true,
          formats: ['xlsx', 'pdf']
        }),
        _createVNode(_component_DxGridToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxGridToolbarItem, { location: "before" }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "continue-application",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToActivities && _ctx.goToActivities(...args)))
                }, [...(_cache[25] || (_cache[25] = [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "folder" }, [
                      _createElementVNode("div", { class: "top" }, [
                        _createElementVNode("svg", { viewBox: "0 0 24 27" }, [
                          _createElementVNode("path", { d: "M0 0h24v27H0z" })
                        ])
                      ]),
                      _createElementVNode("div", { class: "paper" })
                    ]),
                    _createElementVNode("div", { class: "pencil" })
                  ], -1),
                  _createTextVNode(" Vezi pagina de activități ", -1)
                ]))])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_DxButton, {
                    icon: "plus",
                    type: "success",
                    onClick: _ctx.onAddClick,
                    disabled: _ctx.isLocked,
                    hint: "Adauga Activitate"
                  }, null, 8, ["onClick", "disabled"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_DxButton, {
                    icon: "refresh",
                    onClick: _ctx.onRefreshClick,
                    hint: "Reimprospateaza"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "separator" })
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "exportButton",
              hint: "Exporta"
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "separator" })
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "columnChooserButton",
              "locate-in-menu": "auto",
              hint: "Alege Coloanele"
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "searchPanel",
              "locate-in-menu": "auto"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxTexts, {
          "group-continued-message": "Continuat de pe pagina anterioara",
          "group-continues-message": "Continuat pe pagina urmatoare"
        }),
        _createVNode(_component_DxEditing, {
          allowUpdating: !_ctx.isLocked,
          allowDeleting: !_ctx.isLocked,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              closeOnOutsideClick: false,
              showCloseButton: false,
              width: 800,
              height: 650
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxToolbarItem, { template: _ctx.customTitleTemplate }, null, 8, ["template"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.successButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.dangerButtonOptions
                }, null, 8, ["options"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxFormGrid, { "col-count": 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_DxFormItemGrid, {
                  "col-count": 3,
                  "item-type": "group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxFormItemGrid, {
                      "data-field": "TipActivitateID",
                      "col-span": 3,
                      "col-count": 3,
                      label: { text: 'Tip Activitate' },
                      "editor-type": "dxDropDownBox",
                      "editor-options": {
                dataSource: _ctx.dsTipActivitati,
                valueExpr: 'ID',
                displayExpr: _ctx.displayTipActivitate,
                contentTemplate: 'content',
                showClearButton: true
              }
                    }, null, 8, ["editor-options"]),
                    _createVNode(_component_DxFormItemGrid, {
                      dataField: "Cost",
                      editorType: "dxNumberBox",
                      "editor-options": {
              format: '#0.00',
              showSpinButtons: true,
            }
                    }),
                    _createVNode(_component_DxFormItemGrid, { label: { text: 'Valută' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownBox, {
                          opened: _ctx.isValuteGridBoxOpened,
                          "onUpdate:opened": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isValuteGridBoxOpened) = $event)),
                          "data-source": _ctx.valutaSelectat,
                          value: _ctx.sValuta,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sValuta) = $event)),
                          "display-expr": "Simbol",
                          "value-expr": "Id",
                          "show-clear-button": true,
                          placeholder: "RON"
                        }, {
                          content: _withCtx(({ data }) => [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsValuta,
                              value: _ctx.sValuta,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sValuta) = $event)),
                              columns: ['Simbol'],
                              "hover-state-enabled": true,
                              height: "100%",
                              onSelectionChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onValueSelectedValuta($event)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxSelection, { mode: "single" }),
                                _createVNode(_component_DxPaging, {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxSearchPanel, {
                                  visible: true,
                                  placeholder: "Cauta ..."
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "value"])
                          ]),
                          _: 1
                        }, 8, ["opened", "data-source", "value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItemGrid, {
                      dataField: "Data",
                      editorType: "dxDateBox",
                      "editor-options": { displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "Descriere",
                      "col-count": 3,
                      "col-span": 3,
                      "editor-options": { height: 100 },
                      editorType: "dxTextArea"
                    }),
                    _createVNode(_component_DxFormItemGrid, {
                      "item-type": "simple",
                      "col-span": 3
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _cache[34] || (_cache[34] = _createElementVNode("div", { class: "edit-file-title" }, "Documente / Fișiere", -1)),
                          (_ctx.isEditFilesLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Se încarcă..."))
                            : (_ctx.editActivityFiles.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Nu există fișiere atașate. "))
                              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editActivityFiles, (f) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["file-row", { active: _ctx.selectedEditFile?.ID === f.ID }]),
                                      key: f.ID,
                                      onClick: ($event: any) => (_ctx.selectFileForReplace(f))
                                    }, [
                                      _createElementVNode("div", _hoisted_6, _toDisplayString(f.FileName), 1),
                                      _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "dx-button dx-button-mode-text dx-button-normal dx-widget",
                                          title: "Descarcă",
                                          onClick: _withModifiers(($event: any) => (_ctx.onDownloadFile(f)), ["stop"])
                                        }, [...(_cache[28] || (_cache[28] = [
                                          _createElementVNode("span", { class: "dx-button-content" }, [
                                            _createElementVNode("i", { class: "dx-icon dx-icon-download" })
                                          ], -1)
                                        ]))], 8, _hoisted_8)
                                      ])
                                    ], 10, _hoisted_5))
                                  }), 128))
                                ])),
                          (_ctx.editActivityFiles.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  _cache[29] || (_cache[29] = _createTextVNode(" Se va înlocui: ", -1)),
                                  _createElementVNode("b", null, _toDisplayString(_ctx.selectedEditFile?.FileName || '-'), 1)
                                ]),
                                _createElementVNode("input", {
                                  type: "file",
                                  ref: "editFileInput",
                                  style: {"display":"none"},
                                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onReplaceFileSelectedCustom && _ctx.onReplaceFileSelectedCustom(...args)))
                                }, null, 544),
                                _createElementVNode("div", _hoisted_11, [
                                  (_ctx.editReplaceFile)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Nou: " + _toDisplayString(_ctx.editReplaceFile.name), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_13, " (Niciun fișier nou selectat) ")),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "dx-button dx-button-mode-outlined dx-button-normal dx-widget",
                                    disabled: _ctx.isLocked,
                                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.triggerFileSelect && _ctx.triggerFileSelect(...args)))
                                  }, [...(_cache[30] || (_cache[30] = [
                                    _createElementVNode("span", { class: "dx-button-content" }, [
                                      _createElementVNode("i", { class: "dx-icon dx-icon-upload" }),
                                      _createElementVNode("span", { class: "dx-button-text" }, "Alege alt fișier")
                                    ], -1)
                                  ]))], 8, _hoisted_14)
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "dx-button dx-button-mode-outlined dx-button-success dx-widget",
                                    disabled: !_ctx.selectedEditFile?.ID || !_ctx.editReplaceFile,
                                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.replaceCurrentFile && _ctx.replaceCurrentFile(...args)))
                                  }, [...(_cache[31] || (_cache[31] = [
                                    _createElementVNode("span", { class: "dx-button-content" }, [
                                      _createElementVNode("span", { class: "dx-button-text" }, "Înlocuiește")
                                    ], -1)
                                  ]))], 8, _hoisted_16)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_17, [
                            _cache[33] || (_cache[33] = _createElementVNode("div", {
                              class: "edit-file-title",
                              style: {"margin-bottom":"10px"}
                            }, "Adaugă fișiere noi", -1)),
                            _createElementVNode("input", {
                              type: "file",
                              multiple: "",
                              id: "editActivityInputHidden",
                              style: {"display":"none"},
                              onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onEditFileSelectedCustom && _ctx.onEditFileSelectedCustom(...args)))
                            }, null, 32),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                (_ctx.selectedFilesEdit && _ctx.selectedFilesEdit.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFilesEdit, (file, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          style: {"display":"flex","align-items":"center","gap":"6px","font-size":"13px","font-weight":"600","color":"#059669","margin-bottom":"4px"}
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(file.name), 1),
                                          _createElementVNode("span", {
                                            class: "dx-icon-remove",
                                            style: {"cursor":"pointer","color":"#ef4444"},
                                            onClick: ($event: any) => (_ctx.removeEditFile(index)),
                                            title: "Șterge fișier"
                                          }, null, 8, _hoisted_21)
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_22, " (Niciun fișier nou selectat) "))
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "dx-button dx-button-mode-outlined dx-button-normal dx-widget",
                                disabled: _ctx.isLocked,
                                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.triggerEditFileAdd && _ctx.triggerEditFileAdd(...args)))
                              }, [...(_cache[32] || (_cache[32] = [
                                _createElementVNode("span", { class: "dx-button-content" }, [
                                  _createElementVNode("i", { class: "dx-icon dx-icon-upload" }),
                                  _createElementVNode("span", { class: "dx-button-text" }, "Alege fișiere")
                                ], -1)
                              ]))], 8, _hoisted_23)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["allowUpdating", "allowDeleting"]),
        _createVNode(_component_DxStateStoring, {
          enabled: true,
          filterValue: false,
          savingTimeout: 100,
          "storage-key": "gridCardActivitatiState"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TipActivitate.Nume",
          caption: "Tip Activitate"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TipActivitateID",
          visible: false,
          "show-in-column-chooser": false,
          "edit-cell-template": 'accountCellEditorTipActivitate'
        }),
        _createVNode(_component_DxColumn, { "data-field": "Descriere" }),
        _createVNode(_component_DxColumn, {
          "data-field": "Sale.Titlu",
          caption: "Oportunitate",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Account.Nume",
          caption: "Partener"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AccountID",
          visible: false,
          "show-in-column-chooser": false,
          "edit-cell-template": 'accountCellEditor'
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NumeFisier",
          visible: false,
          caption: "Nume Fișier"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Path",
          visible: false,
          caption: "Cale"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Globala",
          visible: false,
          caption: "Globală"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Cost",
          visible: false,
          caption: "Cost"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Durata",
          visible: false,
          caption: "Durată"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Valuta.Simbol",
          visible: false,
          caption: "Valuta"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Curs",
          visible: false,
          caption: "Curs"
        }),
        _createVNode(_component_DxColumn, { "data-field": "Data" }),
        _createVNode(_component_DxColumn, {
          "data-field": "Owner",
          caption: "Responsabil",
          "allow-editing": false
        }),
        _createVNode(_component_DxColumn, {
          type: "buttons",
          "visible-index": 9999,
          "allow-reordering": false,
          "allow-resizing": false,
          width: "90",
          buttons: [
          {
            hint: 'Vezi detalii',
            icon: 'info',
            onClick: _ctx.onViewDetails
          },
          {
            name: 'edit',
            visible: (e) => e.row.data.Owner === _ctx.Username
          },
          {
            name: 'delete',
            visible: (e) => e.row.data.Owner === _ctx.Username
          }
        ]
        }, null, 8, ["buttons"])
      ]),
      _: 1
    }, 8, ["data-source", "onExporting", "onEditingStart", "onRowRemoving", "onRowRemoved"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isActivityDetailsVisible,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isActivityDetailsVisible) = $event)),
      "drag-enabled": false,
      "hide-on-outside-click": true,
      "show-close-button": true,
      width: 750,
      height: 700
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "popup-header-icon dx-icon-task" }, null, -1)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.selectedActivity.TipActivitate || 'Activitate CRM'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("span", {
              class: _normalizeClass(['status-chip', _ctx.selectedActivity.Globala ? 'status-chip--global' : 'status-chip--local'])
            }, _toDisplayString(_ctx.selectedActivity.Globala ? 'Globală' : 'Locală'), 3)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxScrollView, {
          width: "100%",
          height: "100%",
          class: "details-scroll-view"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _cache[37] || (_cache[37] = _createElementVNode("div", { class: "stat-icon dx-icon-money" }, null, -1)),
                  _createElementVNode("div", _hoisted_32, [
                    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "stat-label" }, "Cost Estimativ", -1)),
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.formatCurrency(_ctx.selectedActivity.Cost, _ctx.selectedActivity.Valuta)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _cache[39] || (_cache[39] = _createElementVNode("div", { class: "stat-icon dx-icon-event" }, null, -1)),
                  _createElementVNode("div", _hoisted_35, [
                    _cache[38] || (_cache[38] = _createElementVNode("div", { class: "stat-label" }, "Data Planificată", -1)),
                    _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.formatDate(_ctx.selectedActivity.Data)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "section-header" }, [
                      _createElementVNode("span", { class: "dx-icon-link section-icon" }),
                      _createElementVNode("span", null, "Context Activitate")
                    ], -1)),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _cache[40] || (_cache[40] = _createElementVNode("label", null, "Partener", -1)),
                        _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.selectedActivity.Account || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _cache[41] || (_cache[41] = _createElementVNode("label", null, "Oportunitate Asociată", -1)),
                        _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.selectedActivity.Sale || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _cache[42] || (_cache[42] = _createElementVNode("label", null, "Tip Activitate", -1)),
                        _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.selectedActivity.TipActivitate || '-'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _cache[47] || (_cache[47] = _createElementVNode("div", { class: "section-header" }, [
                        _createElementVNode("span", { class: "dx-icon-floppy section-icon" }),
                        _createElementVNode("span", null, "Documente / Fișiere")
                      ], -1)),
                      _createElementVNode("div", _hoisted_49, [
                        (_ctx.isFilesLoading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [...(_cache[44] || (_cache[44] = [
                              _createElementVNode("div", { class: "value" }, "Se încarcă fișierele...", -1)
                            ]))]))
                          : (_ctx.activityFiles.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [...(_cache[45] || (_cache[45] = [
                                _createElementVNode("div", { class: "value" }, "Nu există fișiere atașate.", -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                _cache[46] || (_cache[46] = _createElementVNode("label", null, "Fișiere", -1)),
                                _createElementVNode("div", _hoisted_53, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityFiles, (f) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "file-row",
                                      key: f.ID
                                    }, [
                                      _createElementVNode("div", _hoisted_54, _toDisplayString(f.FileName), 1),
                                      _createElementVNode("div", _hoisted_55, [
                                        _createVNode(_component_DxButton, {
                                          icon: "download",
                                          "styling-mode": "text",
                                          hint: "Descarcă",
                                          onClick: () => _ctx.onDownloadFile(f)
                                        }, null, 8, ["onClick"])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "section-header" }, [
                      _createElementVNode("span", { class: "dx-icon-doc section-icon" }),
                      _createElementVNode("span", null, "Descriere & Note")
                    ], -1)),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _cache[48] || (_cache[48] = _createElementVNode("label", null, "Descriere Detaliată", -1)),
                        _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.selectedActivity.Descriere || '-'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "section-header" }, [
                      _createElementVNode("span", { class: "dx-icon-info section-icon" }),
                      _createElementVNode("span", null, "Informații Financiare")
                    ], -1)),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _cache[50] || (_cache[50] = _createElementVNode("label", null, "Valoare (Cost)", -1)),
                        _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.formatCurrency(_ctx.selectedActivity.Cost, _ctx.selectedActivity.Valuta)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _cache[51] || (_cache[51] = _createElementVNode("label", null, "Curs Valutar", -1)),
                        _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.selectedActivity.Curs || '1.0000'), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _cache[54] || (_cache[54] = _createElementVNode("span", { class: "dx-icon-user meta-icon" }, null, -1)),
                    _createElementVNode("span", null, [
                      _cache[53] || (_cache[53] = _createTextVNode("Creat de ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.selectedActivity.UserCreat || 'Sistem'), 1),
                      _createTextVNode(" la " + _toDisplayString(_ctx.formatDate(_ctx.selectedActivity.DataCreat, true)), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isModalVisible,
      "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.isModalVisible) = $event)),
      closeOnOutsideClick: false,
      showCloseButton: false,
      showTitle: true,
      width: 700,
      height: 590
    }, {
      title: _withCtx(() => [...(_cache[55] || (_cache[55] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare activitate"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează informațiile în pașii de mai jos ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nouă ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _createVNode(_component_DxForm, { formData: _ctx.formData }, {
              default: _withCtx(() => [
                _createVNode(_component_DxFormItem, {
                  "col-span": 3,
                  "col-count": 3,
                  "item-type": "group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxFormItem, {
                      label: { text: 'Tip Activitate' },
                      "col-count": 3,
                      "col-span": 3
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Tip Activitate' este obligatoriu" }),
                        _createVNode(_component_DxDropDownBox, {
                          opened: _ctx.isTipActivitateGridBoxOpened,
                          "onUpdate:opened": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isTipActivitateGridBoxOpened) = $event)),
                          "data-source": _ctx.tipActivitateSelectat,
                          value: _ctx.sTipActivitate,
                          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.sTipActivitate) = $event)),
                          "show-clear-button": true,
                          "display-expr": "Nume",
                          "value-expr": "ID"
                        }, {
                          content: _withCtx(({ data }) => [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsTipActivitati,
                              value: _ctx.sTipActivitate,
                              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.sTipActivitate) = $event)),
                              columns: ['Nume'],
                              "hover-state-enabled": true,
                              height: "100%",
                              onSelectionChanged: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onValueSelectedTipActivitate($event)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxSelection, { mode: "single" }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxSearchPanel, {
                                  visible: true,
                                  placeholder: "Cauta ..."
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "value"])
                          ]),
                          _: 1
                        }, 8, ["opened", "data-source", "value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "Cost",
                      editorType: "dxNumberBox",
                      "editor-options": {
                format: '#0.00',
                showSpinButtons: true,
              }
                    }),
                    _createVNode(_component_DxFormItem, { label: { text: 'Valuta' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownBox, {
                          opened: _ctx.isValuteGridBoxOpened,
                          "onUpdate:opened": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.isValuteGridBoxOpened) = $event)),
                          "data-source": _ctx.valutaSelectat,
                          value: _ctx.sValuta,
                          "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.sValuta) = $event)),
                          "show-clear-button": true,
                          "display-expr": "Simbol",
                          "value-expr": "Id",
                          placeholder: "RON"
                        }, {
                          content: _withCtx(({ data }) => [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsValuta,
                              value: _ctx.sValuta,
                              "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.sValuta) = $event)),
                              columns: ['Simbol'],
                              "hover-state-enabled": true,
                              height: "100%",
                              onSelectionChanged: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onValueSelectedValuta($event)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxSelection, { mode: "single" }),
                                _createVNode(_component_DxPaging, {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxSearchPanel, {
                                  visible: true,
                                  placeholder: "Cauta ..."
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "value"])
                          ]),
                          _: 1
                        }, 8, ["opened", "data-source", "value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "Data",
                      editorType: "dxDateBox",
                      "editor-options": { displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "Descriere",
                      "col-count": 3,
                      "col-span": 3,
                      "editor-options": { height: 100 },
                      editorType: "dxTextArea"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Descriere' este obligatoriu" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, { "col-span": 3 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("input", {
                            type: "file",
                            multiple: "",
                            ref: "addFileInput",
                            id: "addActivityInputHidden",
                            style: {"display":"none"},
                            onChange: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.onAddFileSelectedCustom && _ctx.onAddFileSelectedCustom(...args)))
                          }, null, 544),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              (_ctx.selectedFiles && _ctx.selectedFiles.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFiles, (file, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        style: {"display":"flex","align-items":"center","gap":"6px","font-size":"13px","font-weight":"600","color":"#059669","margin-bottom":"4px"}
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString(file.name), 1),
                                        _createElementVNode("span", {
                                          class: "dx-icon-remove",
                                          style: {"cursor":"pointer","color":"#ef4444"},
                                          onClick: ($event: any) => (_ctx.removeFile(index)),
                                          title: "Șterge fișier"
                                        }, null, 8, _hoisted_76)
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_77, " (Niciun fișier selectat) "))
                            ]),
                            _createVNode(_component_DxButton, {
                              text: "Alege fișiere",
                              icon: "upload",
                              "styling-mode": "outlined",
                              type: "default",
                              onClick: _ctx.triggerAddFileSelect,
                              disabled: _ctx.isLocked
                            }, null, 8, ["onClick", "disabled"])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["formData"])
          ]),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _createVNode(_component_DxButton, {
                text: "Programează activitate următoare",
                type: "success",
                width: "auto",
                height: "32",
                "styling-mode": "outlined",
                "use-submit-behavior": false,
                onClick: _cache[22] || (_cache[22] = () => _ctx.onSaveAdd(true)),
                disabled: _ctx.isLocked
              }, null, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "success",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _cache[23] || (_cache[23] = () => _ctx.onSaveAdd(false)),
                disabled: _ctx.isLocked
              }, null, 8, ["disabled"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                type: "danger",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"])
            ])
          ])
        ], 512)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}